import { supabase } from '@/shared/config/supabase';
import { IWorkspaceRepository, WorkspaceDTO } from '@/shared/application/use-cases/GetWorkspaceUseCase';

/**
 * Supabase Workspace Repository
 *
 * Implements workspace data access using Supabase
 */
export class SupabaseWorkspaceRepository implements IWorkspaceRepository {
  /**
   * Get workspace by ID
   */
  async getById(id: number): Promise<WorkspaceDTO | null> {
    console.log('SupabaseWorkspaceRepository: Fetching workspace with ID:', id);

    const { data, error } = await supabase
      .from('Workspaces')
      .select('*')
      .eq('id', id)
      .single();

    if (error) {
      if (error.code === 'PGRST116') {
        // Not found - this is OK, just return null
        console.warn(`Workspace with ID ${id} not found in database`);
        return null;
      }
      console.error('Error fetching workspace:', error);
      throw new Error(`Failed to fetch workspace: ${error.message}`);
    }

    console.log('Workspace data fetched:', data);
    return this.mapToDTO(data);
  }

  /**
   * Get workspace by slug
   */
  async getBySlug(slug: string): Promise<WorkspaceDTO | null> {
    const { data, error } = await supabase
      .from('Workspaces')
      .select('*')
      .eq('slug', slug)
      .single();

    if (error) {
      if (error.code === 'PGRST116') {
        // Not found
        return null;
      }
      console.error('Error fetching workspace by slug:', error);
      throw new Error(`Failed to fetch workspace: ${error.message}`);
    }

    return this.mapToDTO(data);
  }

  /**
   * Map database row to DTO
   */
  private mapToDTO(row: { id: number; name: string; slug: string; settings: Record<string, unknown> | null; created_at: string; is_access_blocked: boolean | null; blocked_at: string | null }): WorkspaceDTO {
    return {
      id: row.id,
      name: row.name,
      slug: row.slug,
      settings: row.settings,
      createdAt: row.created_at,
      isAccessBlocked: row.is_access_blocked ?? false,
      blockedAt: row.blocked_at,
    };
  }
}
